<template>
  <div :class="$style.container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="实名认证" name="first">
        <RealNamePopup />
      </el-tab-pane>
    </el-tabs>
    <div :class="$style.goBack" @click="goBack">返回</div>
  </div>
</template>

<script>
import RealNamePopup from "../certify/RealNamePopup.vue";

export default {
  name: "SafeName",
  components: {
    RealNamePopup,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  position: relative;

  :global {
    .el-tabs {
      box-shadow: $box-shadow;

      ::v-deep .el-tabs__content {
        box-shadow: unset;
      }
      ::v-deep .el-tabs__header {
        background-color: $white;
        border-bottom: $border-1;
      }
    }
  }

  .goBack {
    position: absolute;
    top: 0;
    right: rem(60);
    padding: 10px 5px;
    font-size: rem(14);
    color: #333;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }
}
</style>